export default ($axios) => ({
    getCategoryData(slug, queryParams) {
        return $axios({
            method: 'GET',
            url: `/general/v2/category/${slug}/`,
            params: queryParams
        });
    }
});
